import React, { useMemo } from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNavigation } from '../../../common/navigation';
import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { OrderSearch } from './OrderSearch';

export const OrdersCompletedTab: React.FC = () => {
  const pok = usePokCore();
  const nav = useNavigation();
  const { t, tk } = useTranslation('orderLng');

  const getData = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        pok.orders.getAllByPortionCompleted(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [pok.orders, t, tk],
  );

  return (
    <OrderSearch
      getData={getData}
      getCount={pok.orders.getAllCountCompleted}
      onRowClick={nav.orderEditorByTeam}
    />
  );
};
